import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WithOnboardingAnalyticsCategory } from './onboardingAnalytics';
import META from './useTrackViewedOnboardingUpload.meta';

export type ViewedOnboardingUploadParams = WithOnboardingAnalyticsCategory;

export const useTrackViewedOnboardingUpload = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedOnboardingUpload = useCallback(
    (params: ViewedOnboardingUploadParams) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackViewedOnboardingUpload };
};
